// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"272":"2ac525a8","563":"1c356fdf"}[chunkId] + ".css";
};